import { render, staticRenderFns } from "./ListResource.vue?vue&type=template&id=43e02056&"
import script from "./ListResource.vue?vue&type=script&lang=js&"
export * from "./ListResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports